import PropTypes from 'prop-types';
import { useTableRowGroup } from 'react-aria';

const TableRowGroup = ({ type: Element, className, children, ...props }) => {
    const { rowGroupProps } = useTableRowGroup();
    return (
        <Element {...rowGroupProps} className={className} data-testid={props['data-testid']}>
            {children}
        </Element>
    );
};

TableRowGroup.propTypes = {
    children: PropTypes.any,
    type: PropTypes.any,
    className: PropTypes.string,
    'data-testid': PropTypes.string
};

export default TableRowGroup;
